var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9798 16.7757V6.95502C17.4661 8.59553 20.1663 10.1803 23.3598 11.8889C20.7258 13.3496 17.4661 14.9886 13.9798 16.7757ZM33.4093 2.07075C32.8079 1.27842 31.7829 0.661655 30.6917 0.457465C27.4842 -0.151622 7.47422 -0.153354 4.26852 0.457465C3.39344 0.621511 2.61421 1.01803 1.94483 1.6341C-0.875634 4.25193 0.00816581 18.2905 0.688007 20.5645C0.973888 21.5488 1.34346 22.2587 1.80889 22.7247C2.40854 23.3407 3.22957 23.7649 4.17263 23.9551C6.81354 24.5014 20.4191 24.8068 30.6358 24.0372C31.5772 23.8731 32.4104 23.4353 33.0676 22.793C35.6754 20.1857 35.4976 5.35873 33.4093 2.07075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0f02313570f1dcb713a55da63c41181d.svg";
export { ForwardRef as ReactComponent };